import {
    cloneDeep,
    countBy,
    entries,
    flow,
    head,
    isNil,
    last,
    maxBy,
    minBy,
    partialRight,
    uniqBy,
} from "lodash";
import AggrTypes from "../queries/technogroup-result-details/AggrTypes";
import {isFiniteNumber} from "./MathUtils";
import {evalInScope} from "./Utils";

function getMostCommon(array, field) {
    console.log(flow(countBy)(array, field));
    console.log(
        flow(countBy, entries, partialRight(maxBy, last))(array, field)
    );
    return flow(
        countBy,
        entries,
        partialRight(maxBy, last),
        head
    )(array, field);
}

export function createDetail(
    aggregate,
    aggregateOptions,
    field,
    pageData,
    filteredData,
    {cache = {}, cacheKey, formatter, onlyGlobal}
) {
    let tmpCacheKey = cacheKey || field;
    try {
        switch (aggregate) {
            case AggrTypes.NONE: {
                return null;
            }
            case AggrTypes.AVERAGE: {
                const startingValue = {mass: 0, count: 0};
                const handler = (acc, cur) => {
                    if (!isNil(cur[field])) {
                        const mass = evalInScope(
                            aggregateOptions?.massKey || field,
                            cur
                        );
                        if (isFiniteNumber(mass)) {
                            acc.mass = acc.mass + mass;
                            acc.count +=
                                evalInScope(
                                    aggregateOptions?.countKey || "1",
                                    cur
                                ) || 0;
                        }
                        return acc;
                    }
                    return acc;
                };
                const afterReduce = (reduceResult) =>
                    reduceResult.count
                        ? +(reduceResult.mass / reduceResult.count).toFixed(
                              aggregateOptions?.fixed ?? 4
                          )
                        : 0;
                const global =
                    cache[tmpCacheKey] ||
                    filteredData.reduce(handler, cloneDeep(startingValue));
                cache[tmpCacheKey] = global;
                if (onlyGlobal) {
                    if (formatter) return `~${formatter(afterReduce(global))}`;
                    return `~${afterReduce(global)}`;
                }
                const local = pageData.reduce(
                    handler,
                    cloneDeep(startingValue)
                );
                if (formatter) {
                    return `~${formatter(afterReduce(local))} | ~${formatter(
                        afterReduce(global)
                    )}`;
                }
                return `~${afterReduce(local)} | ~${afterReduce(global)}`;
            }
            case AggrTypes.COUNT_DISTINCT: {
                const global =
                    cache[tmpCacheKey] || uniqBy(filteredData, field).length;
                cache[tmpCacheKey] = global;
                if (onlyGlobal) {
                    if (formatter) return formatter(global);
                    return global;
                }
                const local = uniqBy(filteredData, field).length;
                if (formatter) {
                    return `${formatter(local)} | ${formatter(global)}`;
                }
                return `${local} | ${global}`;
            }
            case AggrTypes.MOST_COMMON: {
                const global =
                    cache[tmpCacheKey] || getMostCommon(filteredData, field);
                cache[tmpCacheKey] = global;
                if (onlyGlobal) {
                    if (
                        global === null ||
                        global === undefined ||
                        global === "null" // getMostCommon zwraca wartosci jako string
                    )
                        return "";
                    if (formatter) return formatter(global);
                    return global;
                }
                const local = getMostCommon(pageData, field);
                if (formatter) {
                    return `${formatter(local)} | ${formatter(global)}`;
                }
                return `${local} | ${global}`;
            }
            case AggrTypes.MIN: {
                const global =
                    cache[tmpCacheKey] || minBy(filteredData, field)?.[field];
                cache[tmpCacheKey] = global;
                if (onlyGlobal) {
                    if (formatter) return formatter(global);
                    return global;
                }
                const local = minBy(pageData, field)?.[field];
                if (formatter) {
                    return `${formatter(local)} | ${formatter(global)}`;
                }
                return `${local} | ${global}`;
            }
            case AggrTypes.MAX: {
                const global =
                    cache[tmpCacheKey] || maxBy(filteredData, field)?.[field];
                cache[tmpCacheKey] = global;
                if (onlyGlobal) {
                    if (formatter) return formatter(global);
                    return global;
                }
                const local = maxBy(pageData, field)?.[field];
                if (formatter) {
                    return `${formatter(local)} | ${formatter(global)}`;
                }
                return `${local} | ${global}`;
            }
            default: {
                const handler = (acc, cur) => acc + (cur[field] ?? 0);
                const startingValue = 0;
                const global =
                    cache[tmpCacheKey] ||
                    filteredData.reduce(handler, startingValue);
                cache[tmpCacheKey] = global;
                if (onlyGlobal) {
                    if (formatter) return formatter(global);
                    return global;
                }
                const local = pageData.reduce(handler, startingValue);
                return `${+local.toFixed(
                    aggregateOptions?.fixed ?? 1
                )} | ${+global.toFixed(aggregateOptions?.fixed ?? 1)}`;
            }
        }
    } catch (e) {
        console.error(e);
        return `? | ?`;
    }
}
